import { APP_VERSION, formatSidebarVersion } from '@gridorbit/shared';

export function getSidebarVersionLabel(): string {
  return formatSidebarVersion(
    import.meta.env.VITE_APP_VERSION || APP_VERSION,
    import.meta.env.VITE_BUILD_LABEL,
  );
}

export function SidebarVersion() {
  return (
    <div className={'sidebar-version'} title={'GridOrbit 前端版本'}>
      {getSidebarVersionLabel()}
    </div>
  );
}
